import controller from './pqrs-list.controller';
import template from './pqrs-list.view.html';

let PqrsListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PqrsListComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pqrs/pqrs-list/pqrs-list.component.js
 **/